import React, { Suspense } from "react";

import { Box, GDSBoxProps, GDSStyleObject } from "@leagueplatform/genesis-core";
import { useScrollTopOnLocationChange } from "@leagueplatform/web-common";
import { ObservabilityErrorBoundary } from "@leagueplatform/observability";
import {
  ErrorState,
  LoadingIndicator,
} from "@leagueplatform/web-common-components";
import { useIntl } from "@leagueplatform/locales";
import { HEADER_NAV_BAR_DEFAULT_HEIGHT } from "@leagueplatform/solutions-foundation";
import { AppNavBarComponent } from "components/header-nav/header-nav.component";
import { AppFooter } from "components/app-footer/app-footer.component";

type BasePageProps = GDSBoxProps<"div"> & {
  css?: GDSStyleObject;
  isPrivatePage?: boolean;
};

export const BasePage: React.FC<BasePageProps> = ({
  children,
  isPrivatePage = true,
  css,
  ...boxProps
}) => {
  useScrollTopOnLocationChange();
  const { formatMessage } = useIntl();

  const mainContentMinHeight = isPrivatePage
    ? `calc(100vh - ${HEADER_NAV_BAR_DEFAULT_HEIGHT}px)`
    : "100vh";

  return (
    <>
      {isPrivatePage && <AppNavBarComponent />}
      <Box
        as="main"
        id="main-content"
        css={{
          position: "relative",
          flex: "1",
          minHeight: mainContentMinHeight,
          overflowX: "hidden",
          ...css,
        }}
        {...boxProps}
      >
        <Suspense fallback={<LoadingIndicator />}>
          <ObservabilityErrorBoundary
            fallback={
              <ErrorState
                headingString={formatMessage({
                  id: "STR_ERROR_STATE_HEADING_GENERIC",
                })}
                bodyString={formatMessage({ id: "STR_ERROR_STATE_BODY_API" })}
                buttonText={formatMessage({ id: "STR_RELOAD" })}
                error={null}
              />
            }
            errorContext={{
              context: {
                Context: { location: "Base Page ErrorBoundary" },
              },
            }}
          >
            {children}
          </ObservabilityErrorBoundary>
        </Suspense>
      </Box>
      {isPrivatePage && <AppFooter />}
    </>
  );
};
